// import { useState } from "react";
// import { Link } from "react-router-dom";
// import { Search, SlidersHorizontal, Star, MapPin } from "lucide-react";
// import Navbar from "../components/landingPage/Navbar";
// import Footer from "../components/landingPage/Footer";

// const centres = [
//   { city: "Visakhapatnam", rating: 4.8, machines: 42, experts: 18, utilised: 78 },
//   { city: "Vijayawada", rating: 4.7, machines: 36, experts: 14, utilised: 71 },
//   { city: "Tirupati", rating: 4.6, machines: 29, experts: 12, utilised: 65 },
//   { city: "Kurnool", rating: 4.5, machines: 24, experts: 9, utilised: 58 },
// ];

// export default function Facilities() {
//   const [view, setView] = useState("list");
//   const [query, setQuery] = useState("");

//   const filtered = centres.filter((c) =>
//     c.city.toLowerCase().includes(query.toLowerCase())
//   );

//   return (
//     <div>
//       <Navbar />

//       {/* Header band */}
//       <section className="bg-gradient-to-br from-[#1e1b4b] via-[#312e81] to-[#4c1d95] text-white">
//         <div className="max-w-7xl mx-auto px-6 pt-14 pb-24">
//           <span className="inline-block text-xs font-semibold bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-5">
//             Innovation Centres
//           </span>
//           <h1 className="text-4xl md:text-5xl font-extrabold mb-3">
//             Explore APIC Facilities
//           </h1>
//           <p className="text-indigo-100">
//             Discover state-of-the-art prototyping infrastructure across Andhra Pradesh.
//           </p>
//         </div>
//       </section>

//       {/* Search bar - overlaps header/body */}
//       <div className="max-w-7xl mx-auto px-6 -mt-12">
//         <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-3 flex flex-wrap items-center gap-3">
//           <div style={{border:"1px solid #f0f0f0", borderRadius:"8px"}} className="flex items-center flex-1 min-w-[220px] gap-2 px-3">
//             <Search className="w-4 h-4 text-gray-400" />
//             <input
//               value={query}
//               onChange={(e) => setQuery(e.target.value)}
//               placeholder="Search centre, city or technology..."
//               className="w-full py-2.5 text-sm focus:outline-none"
//             />
//           </div>

//           <button
//             type="button"
//             className="flex items-center gap-2 border border-gray-200 rounded-xl px-4 py-2.5 text-sm font-medium hover:bg-gray-50"
//           >
//             <SlidersHorizontal className="w-4 h-4" />
//             Filters
//           </button>

//           <div className="flex bg-gray-100 rounded-xl p-1">
//             <button
//               type="button"
//               onClick={() => setView("list")}
//               className={`px-4 py-2 text-sm font-semibold rounded-lg transition ${
//                 view === "list" ? "bg-indigo-600 text-white" : "text-gray-600"
//               }`}
//             >
//               List
//             </button>
//             <button
//               type="button"
//               onClick={() => setView("map")}
//               className={`px-4 py-2 text-sm font-semibold rounded-lg transition ${
//                 view === "map" ? "bg-indigo-600 text-white" : "text-gray-600"
//               }`}
//             >
//               Map
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Content */}
//       <main className="max-w-7xl mx-auto px-6 py-12">
//         {view === "list" ? (
//           <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
//             {filtered.map(({ city, rating, machines, experts, utilised }) => (
//               <div
//                 key={city}
//                 className="rounded-2xl overflow-hidden border border-gray-100 shadow-sm"
//               >
//                 <div className="h-32 bg-gradient-to-br from-indigo-600 to-blue-500 relative p-4 flex flex-col justify-between">
//                   <span className="self-end flex items-center gap-1 bg-white/20 backdrop-blur text-white text-xs font-semibold px-2.5 py-1 rounded-full">
//                     <Star className="w-3 h-3 fill-white" /> {rating}
//                   </span>
//                   <div className="text-white">
//                     <p className="font-bold text-lg leading-tight">APIC {city}</p>
//                     <p className="flex items-center gap-1 text-sm text-indigo-100">
//                       <MapPin className="w-3.5 h-3.5" /> {city}
//                     </p>
//                   </div>
//                 </div>

//                 <div className="p-5">
//                   <div className="grid grid-cols-3 text-center mb-5">
//                     <div>
//                       <p className="font-bold text-gray-900">{machines}</p>
//                       <p className="text-[11px] text-gray-500 tracking-wide">MACHINES</p>
//                     </div>
//                     <div>
//                       <p className="font-bold text-gray-900">{experts}</p>
//                       <p className="text-[11px] text-gray-500 tracking-wide">EXPERTS</p>
//                     </div>
//                     <div>
//                       <p className="font-bold text-gray-900">{utilised}%</p>
//                       <p className="text-[11px] text-gray-500 tracking-wide">UTILISED</p>
//                     </div>
//                   </div>

//                   <div className="flex gap-3">
//                     <Link
//                       to={`/facilities/${city.toLowerCase()}/book`}
//                       className="flex-1 text-center bg-gradient-to-r from-indigo-600 to-blue-600 text-white text-sm font-semibold py-2.5 rounded-xl hover:opacity-90 transition"
//                     >
//                       Book a Machine
//                     </Link>
//                     <Link
//                       to={`/facilities/${city.toLowerCase()}`}
//                       className="flex-1 text-center border border-gray-200 text-sm font-semibold py-2.5 rounded-xl hover:bg-gray-50 transition"
//                     >
//                       Details
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <div className="h-96 rounded-2xl border border-dashed border-gray-300 flex items-center justify-center text-gray-400">
//             Map view coming soon
//           </div>
//         )}
//       </main>

//       <Footer />
//     </div>
//   );
// }



// Facilities.jsx
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { 
  Search, 
  SlidersHorizontal, 
  Star, 
  MapPin, 
  X,
  Calendar,
  Clock,
  Users,
  Cpu,
  Mail,
  Phone,
  User,
  MessageCircle,
  CheckCircle,
  ArrowRight,
  Building2,
  Sparkles
} from "lucide-react";

import "./Facilities.css";

const centres = [
  { 
    id: 1,
    city: "Visakhapatnam", 
    rating: 4.8, 
    machines: 42, 
    experts: 18, 
    utilised: 78,
    address: "Plot No. 123, APIIC Industrial Park, Visakhapatnam, AP - 530001",
    phone: "+91 891-234-5678",
    email: "vizag@apicprotohub.in",
    description: "State-of-the-art prototyping facility with advanced 3D printing and CNC machining capabilities.",
    facilities: ["3D Printing", "CNC Machining", "PCB Prototyping", "Laser Cutting"],
    hours: "Mon-Sat: 9:00 AM - 6:00 PM",
    image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
  },
  { 
    id: 2,
    city: "Vijayawada", 
    rating: 4.7, 
    machines: 36, 
    experts: 14, 
    utilised: 71,
    address: "Survey No. 45, Industrial Area, Vijayawada, AP - 520001",
    phone: "+91 866-345-6789",
    email: "vijayawada@apicprotohub.in",
    description: "Innovation hub with focus on robotics, automation, and product design prototyping.",
    facilities: ["Robotics", "Automation", "3D Scanning", "Product Design"],
    hours: "Mon-Sat: 9:00 AM - 6:00 PM",
    image: "https://images.unsplash.com/photo-1581092335871-5f2b5e17cd7a?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
  },
  { 
    id: 3,
    city: "Tirupati", 
    rating: 4.6, 
    machines: 29, 
    experts: 12, 
    utilised: 65,
    address: "Plot No. 78, IT Park, Tirupati, AP - 517501",
    phone: "+91 877-456-7890",
    email: "tirupati@apicprotohub.in",
    description: "Advanced manufacturing facility specializing in aerospace components and precision engineering.",
    facilities: ["Precision Engineering", "Aerospace", "Quality Testing", "Material Science"],
    hours: "Mon-Sat: 9:00 AM - 6:00 PM",
    image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
  },
  { 
    id: 4,
    city: "Kurnool", 
    rating: 4.5, 
    machines: 24, 
    experts: 9, 
    utilised: 58,
    address: "Plot No. 234, Industrial Hub, Kurnool, AP - 518001",
    phone: "+91 851-567-8901",
    email: "kurnool@apicprotohub.in",
    description: "Emerging innovation centre with focus on sustainable manufacturing and renewable energy prototyping.",
    facilities: ["Sustainable Manufacturing", "Renewable Energy", "IoT", "Smart Sensors"],
    hours: "Mon-Sat: 9:00 AM - 6:00 PM",
    image: "https://images.unsplash.com/photo-1581092335871-5f2b5e17cd7a?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
  }
];

// ========== BOOKING POPUP ==========
function BookingPopup({ centre, onClose, onConfirm }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    machine: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(formData);
  };

  if (!centre) return null;

  return (
    <div className="booking-overlay" onClick={onClose}>
      <div className="booking-popup" onClick={(e) => e.stopPropagation()}>
        <button className="booking-close" onClick={onClose}>
          <X size={24} />
        </button>

        <div className="booking-header">
          <div className="booking-centre-info">
            <div className="booking-centre-icon">
              <Building2 size={24} />
            </div>
            <div>
              <h3 className="booking-centre-name">APIC {centre.city}</h3>
              <p className="booking-centre-location">
                <MapPin size={14} />
                {centre.address}
              </p>
            </div>
          </div>
          <div className="booking-rating">
            <Star size={16} fill="#f59e0b" stroke="#f59e0b" />
            <span>{centre.rating}</span>
          </div>
        </div>

        <form className="booking-form" onSubmit={handleSubmit}>
          <div className="booking-form-row">
            <div className="booking-form-group">
              <label>
                <User size={16} />
                Full Name *
              </label>
              <input
                type="text"
                name="name"
                placeholder="Enter your full name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="booking-form-group">
              <label>
                <Mail size={16} />
                Email Address *
              </label>
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="booking-form-group">
            <label>
              <Phone size={16} />
              Phone Number *
            </label>
            <input
              type="tel"
              name="phone"
              placeholder="Enter your phone number"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="booking-form-row">
            <div className="booking-form-group">
              <label>
                <Calendar size={16} />
                Booking Date *
              </label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </div>
            <div className="booking-form-group">
              <label>
                <Clock size={16} />
                Preferred Time *
              </label>
              <input
                type="time"
                name="time"
                value={formData.time}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="booking-form-group">
            <label>
              <Cpu size={16} />
              Machine Type
            </label>
            <select name="machine" value={formData.machine} onChange={handleChange}>
              <option value="">Select a machine type</option>
              {centre.facilities.map((facility, index) => (
                <option key={index} value={facility}>{facility}</option>
              ))}
            </select>
          </div>

          <div className="booking-form-group">
            <label>
              <MessageCircle size={16} />
              Additional Details
            </label>
            <textarea
              name="message"
              placeholder="Any specific requirements or details..."
              rows="3"
              value={formData.message}
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="booking-summary">
            <div className="booking-summary-item">
              <span>Centre</span>
              <span>APIC {centre.city}</span>
            </div>
            <div className="booking-summary-item">
              <span>Machines Available</span>
              <span>{centre.machines}</span>
            </div>
            <div className="booking-summary-total">
              <span>Booking Fee</span>
              <span>₹0 (Free)</span>
            </div>
          </div>

          <button type="submit" className="booking-submit">
            <Calendar size={18} />
            Confirm Booking
          </button>

          <p className="booking-note">
            <CheckCircle size={14} />
            You will receive a confirmation email shortly
          </p>
        </form>
      </div>
    </div>
  );
}

// ========== MAIN COMPONENT ==========
export default function Facilities() {
  const navigate = useNavigate();
  const [view, setView] = useState("list");
  const [query, setQuery] = useState("");
  const [selectedCentre, setSelectedCentre] = useState(null);
  const [showBooking, setShowBooking] = useState(false);

  const filtered = centres.filter((c) =>
    c.city.toLowerCase().includes(query.toLowerCase()) ||
    c.facilities.some(f => f.toLowerCase().includes(query.toLowerCase()))
  );

  const handleBook = (centre) => {
    setSelectedCentre(centre);
    setShowBooking(true);
    document.body.style.overflow = 'hidden';
  };

  const closeBooking = () => {
    setShowBooking(false);
    setSelectedCentre(null);
    document.body.style.overflow = 'unset';
  };

  const handleBookingConfirm = (data) => {
    console.log('Booking confirmed:', data);
    alert(`✅ Booking confirmed at APIC ${selectedCentre.city}!\n\nName: ${data.name}\nEmail: ${data.email}\nDate: ${data.date}\nTime: ${data.time}\nMachine: ${data.machine || 'Not specified'}`);
    closeBooking();
  };

  const handleDetails = (centre) => {
    navigate(`/facility/${centre.id}`);
  };

  return (
    <div className="facilities-page">


      {/* Header band */}
      <section className="facilities-hero">
        <div className="facilities-hero-content">
          <span className="facilities-hero-badge">
            <Sparkles size={16} />
            Innovation Centres
          </span>
          <h1 className="facilities-hero-title">
            Explore APIC <span>Facilities</span>
          </h1>
          <p className="facilities-hero-desc">
            Discover state-of-the-art prototyping infrastructure across Andhra Pradesh.
          </p>
        </div>
      </section>

      {/* Search bar - overlaps header/body */}
      <div className="facilities-search-wrapper">
        <div className="facilities-search-bar">
          <div className="facilities-search-input">
            <Search className="facilities-search-icon" />
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search centre, city or technology..."
              className="facilities-search-field"
            />
          </div>

          <button type="button" className="facilities-filter-btn">
            <SlidersHorizontal className="w-4 h-4" />
            Filters
          </button>

          <div className="facilities-view-toggle">
            <button
              type="button"
              onClick={() => setView("list")}
              className={`facilities-view-btn ${view === "list" ? "active" : ""}`}
            >
              List
            </button>
            <button
              type="button"
              onClick={() => setView("map")}
              className={`facilities-view-btn ${view === "map" ? "active" : ""}`}
            >
              Map
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <main className="facilities-main">
        {view === "list" ? (
          <>
            <div className="facilities-results">
              <span>{filtered.length}</span> centres found
            </div>
            <div className="facilities-grid">
              {filtered.map((centre) => (
                <div key={centre.id} className="facility-card">
                  <div className="facility-card-image">
                    <img src={centre.image} alt={`APIC ${centre.city}`} />
                    <div className="facility-card-badge">
                      <Star className="facility-card-star" />
                      <span>{centre.rating}</span>
                    </div>
                  </div>

                  <div className="facility-card-content">
                    <div className="facility-card-header">
                      <h3 className="facility-card-title">APIC {centre.city}</h3>
                      <div className="facility-card-location">
                        <MapPin className="w-3.5 h-3.5" />
                        <span>{centre.city}</span>
                      </div>
                    </div>

                    <div className="facility-card-stats">
                      <div className="facility-card-stat">
                        <Cpu className="w-4 h-4" />
                        <span>{centre.machines} Machines</span>
                      </div>
                      <div className="facility-card-stat">
                        <Users className="w-4 h-4" />
                        <span>{centre.experts} Experts</span>
                      </div>
                      <div className="facility-card-stat">
                        <span className="facility-utilization">{centre.utilised}%</span>
                        <span>Utilized</span>
                      </div>
                    </div>

                    <div className="facility-card-footer">
                      <button 
                        className="facility-book-btn"
                        onClick={() => handleBook(centre)}
                      >
                        <Calendar className="w-4 h-4" />
                        Book a Machine
                      </button>
                      <button 
                        className="facility-details-btn"
                        onClick={() => handleDetails(centre)}
                      >
                        Details
                        <ArrowRight className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {filtered.length === 0 && (
              <div className="facilities-no-results">
                <div className="facilities-no-results-icon">
                  <Search size={32} />
                </div>
                <h4>No centres found</h4>
                <p>Try adjusting your search criteria</p>
                <button onClick={() => setQuery('')}>Clear search</button>
              </div>
            )}
          </>
        ) : (
          <div className="facilities-map-placeholder">
            <div className="facilities-map-content">
              <MapPin className="w-12 h-12" />
              <h3>Map View Coming Soon</h3>
              <p>Interactive map showing all APIC centres across Andhra Pradesh</p>
            </div>
          </div>
        )}
      </main>

      {/* Booking Popup */}
      {showBooking && (
        <BookingPopup 
          centre={selectedCentre}
          onClose={closeBooking}
          onConfirm={handleBookingConfirm}
        />
      )}

     
    </div>
  );
}